import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputNumber, InputSelect, InputSwitch, InputPicklist } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './address-model';  //editable..

interface IProps { 
    history: History;
    caption?: string;
    parentType?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class AddressDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} caption={this.props.caption}
                model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} readOnly/>
                {this.state.datarow.type.startsWith('address-') &&
                <>
                <InputMultiline name='street' label='Street, RT, RW, No.' value={this.state.datarow.street} readOnly/>
                <InputPicklist name='region' label='Kel/Desa, Kec, Kota, Provinsi' value={this.state.datarow.region} caption={this.state.datarow.regionCaption} readOnly/>
                </>
                }
                <Input name='link' label='Link' value={this.state.datarow.link} readOnly/>
                <InputNumber name='seq' label='Sequence' value={this.state.datarow.seq} readOnly/>
                 
            </BaseDelete>
        );
    }
}